// components/finance/sections/RevenueDashboard.jsx
import React, { useMemo } from 'react';
import { RevenueChart } from './RevenueCharts';

export const RevenueDashboard = ({ data, dateRange, summaryStats, loading, error }) => {
  
  // ✅ Move useMemo BEFORE any early returns
  const categoryTotals = useMemo(() => {
    if (!data || data.length === 0) return null;
    
    return data.reduce((acc, month) => ({
      retainer: acc.retainer + (month.retainer_revenue || 0),
      project: acc.project + (month.project_revenue || 0),
      other: acc.other + (month.other_revenue || 0),
      total: acc.total + (month.revenue || 0),
      lastYearTotal: acc.lastYearTotal + (month.last_year_revenue || 0)
    }), { retainer: 0, project: 0, other: 0, total: 0, lastYearTotal: 0 });
  }, [data]);

  // ✅ Early returns come AFTER all hooks
  if (loading) {
    return (
      <div className="flex justify-center items-center h-64">
        <div className="flex items-center space-x-3">
          <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-blue-600"></div>
          <span className="text-gray-600">Loading revenue data...</span>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="p-4 text-red-700 bg-red-100 rounded-lg border border-red-200">
        <div className="flex items-center">
          <span className="text-red-600 text-sm">⚠️ {error}</span>
        </div>
      </div>
    );
  }

  if (!data || data.length === 0) {
    return (
      <div className="text-center py-12">
        <div className="text-6xl mb-4">📈</div>
        <h3 className="text-lg font-medium text-gray-900 mb-2">No Revenue Data Available</h3>
        <p className="text-gray-500">
          No revenue data found for the selected period. Try adjusting your date range.
        </p>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      {/* Revenue Chart */}
      <div className="bg-white rounded-lg border border-gray-200">
        <div className="p-6">
          <RevenueChart 
            data={data} 
            dateRange={dateRange}
            summaryStats={{
              ...summaryStats,
              last_year_revenue: categoryTotals?.lastYearTotal
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default RevenueDashboard;